export default __webpack_public_path__ + "maps-examples-style-circles-categorically-1200-e0d1e94f3c90b459265cb04bfcd0d173.webp";